import { ReactNode } from 'react';

interface DropdownProps<T> {
  isOpen: boolean;
  onClose: () => void;
  items: T[];
  renderTrigger: (isOpen: boolean) => ReactNode;
  renderItem: (item: T, isSelected: boolean) => ReactNode;
  selectedValue?: string | number;
  getItemKey: (item: T) => string | number;
  onSelect: (item: T) => void;
  align?: 'left' | 'right';
  width?: string;
  borderColor?: string;
  background?: string;
}

export function Dropdown<T>({
  isOpen,
  onClose,
  items,
  renderTrigger,
  renderItem,
  selectedValue,
  getItemKey,
  onSelect,
  align = 'left',
  width = '120px',
  borderColor,
  background,
}: DropdownProps<T>) {
  return (
    <div className="relative">
      {renderTrigger(isOpen)}

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={onClose} />
          
          <div
            className={`absolute ${align === 'left' ? 'left-0' : 'right-0'} top-full mt-2 rounded-2xl border shadow-xl z-20 overflow-hidden backdrop-blur-xl`}
            style={{ 
              width,
              borderColor, 
              background 
            }}
          >
            {items.map((item) => {
              const key = getItemKey(item);
              const isSelected = selectedValue === key;
              
              return (
                <button
                  key={key}
                  type="button"
                  onClick={() => {
                    onSelect(item);
                    onClose();
                  }}
                  className={`w-full px-4 py-2.5 text-left text-xs transition-colors hover:bg-white/10 ${
                    isSelected ? 'text-[#6c7bff] bg-white/5' : 'text-white/90'
                  }`}
                >
                  {renderItem(item, isSelected)}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
